import _ from "lodash";
import moment from "moment";
import Record from "@/mixins/Record";

// Form validations
import { required, numeric, minLength } from "vuelidate/lib/validators";

import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import * as queries_custom from '@/graphql/queries_custom';
import aws_exports from "@/aws-exports";
const uuidv1 = require('uuid/v1');
const { v4: uuidv4 } = require('uuid');
    
import AttachmentsForm from '@/components/DynamicForm/Attachments/AttachmentsForm'
const AttachmentsFormMixin = {
    methods: {
        add: AttachmentsForm.methods.add,
        updateAttachment: AttachmentsForm.methods.updateAttachment,
        createAttachment: AttachmentsForm.methods.createAttachment,
        deleteAttachments: AttachmentsForm.methods.deleteAttachments,
        createRelations: AttachmentsForm.methods.createRelations,
        getAwsCredentials: AttachmentsForm.methods.getAwsCredentials,
        onComplete: AttachmentsForm.methods.onComplete,
        showNotification: AttachmentsForm.methods.showNotification,
        uploadFile: AttachmentsForm.methods.uploadFile,
        uploadToAwsS3: AttachmentsForm.methods.uploadToAwsS3,
    }
}

export default {
    mixins: [Record, AttachmentsFormMixin],
    computed: {
        isCommentButtonDisabled() {
            let commentStr = this.getCommentAsPlainText();
            return commentStr.length || this.attachmentData.length ? false : true;
        },
        attachmentRelations() {
            const relations = [];

            const recordData = this.recordData;
            if (!recordData || !recordData.id) {
                return relations;
            }

            // task relation
            relations.push({ fromModelType: 'Task', relationTaskId: recordData.id });
            
            // case relation
            if (this.recordData.case) {
                relations.push({ fromModelType: 'Case', relationCaseId: this.recordData.case.id })
            }

            // service relations
            // if (this.recordData.services && this.recordData.services.items && this.recordData.services.items.length) {
            //     for (const _service of this.recordData.services.items) {
            //         relations.push({ fromModelType: 'Service', relationServiceId: _service.id })
            //     }
            // } else {
            //     const serviceItems = this.$reduce(this, 'recordData.case.services.items') || [];
            //     for (let i = 0; i < serviceItems.length; i++) {
            //         const serviceId = this.$reduce(serviceItems, `${i}.service.id`);
            //         if (serviceId) {
            //             relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
            //         }
            //     }
            // }
            
            const serviceItems = this.$reduce(this, 'recordData.case.services.items') || [];
            for (let i = 0; i < serviceItems.length; i++) {
                const serviceId = this.$reduce(serviceItems, `${i}.service.id`);
                if (serviceId) {
                    relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
                }
            }

            return relations;
        },
        isTaskDisabled() {
            if (!this.recordData || !this.recordData.id) {
                return false;
            }
            if ("Completed" == this.recordData.status) {
                return true;
            }
            if (this.recordData.case.isCompleteInOrder && !this.recordData.isAvailable) {
                return true;
            }
            const steps = this.$reduce(this, "recordData.steps.items");
            if (!steps || !steps.length) {
                if (this.isCompleteInOrder) {
                    return !this.recordData.isAvailable;
                }
                return false;
            }
            const completedSteps = steps.filter((_step) => _step.status && "complete" == _step.status.toLowerCase());
            return steps.length != completedSteps.length;
        },
        auditLogFilter: function () {
            let activeModelId = this.$route.params.id;
            if (this.iframeModelId) {
                activeModelId = this.iframeModelId;
            }
            return [
                { match_phrase: { modelName: 'Task' } },
                { match_phrase: { modelId: activeModelId } },
            ];
        },
        feedActive() {
            const length = this.feedPage * this.feedItemsPerPage;
            return this.feedFiltered.slice(0, length);
        },
        groupIndex() {
            let index = 1;
            if (this.recordData && this.recordData.group) {
                let group = parseInt(this.recordData.group);
                if (!isNaN(group)) {
                    index = group;
                }
            }
            return index;
        },
        orderIndex() {
            let index = 1;
            if (this.recordData && this.recordData.order) {
                let order = parseInt(this.recordData.order);
                if (!isNaN(order)) {
                    index = order;
                }
            }
            return index;
        },
    },
    data() {
        return {
            attachmentsTimeoutId: null,
            userListItems: [],
            auditLogDialog: false,
            reservedNameValidatorTimeoutId: null,
            isFirstTimeReservedNameCheck: true,
            auditLogList: {
                class: 'auditLogList',
                hideItemActions: true,
                hideListHeader: true,
                skipCardLayout: true,
                hideNewRecordButton: true,
                searchRecordsInput: false,
                hideActionColumn: true,
                pageTitle: "Change History",
                listQueryId: "searchChangesCustom",
                responseFieldName: "searchChanges",
                columns: {
                    user: { label: "Changed By", sortable: false, size: 10 },
                    fieldName: { label: "Field", sortable: false, size: 10 },
                    oldValue: { label: "Old Value", sortable: false, size: 10 },
                    newValue: { label: "New Value", sortable: false, size: 10 },
                    createdAt: { label: "Change Date", sortable: true, dateFilter: true, size: 15 },
                    //action: { label: "Activity", sortable: false, size: 10 },
                    //change: { label: "Change", sortable: false, format: "json", size: 55 },
                },
                //hyperlink config based on admin role
                linkConfigs: this.$Session && this.$Session.isAdminGroupMember ? [
                    {
                    name: 'user',
                    hrefCallback: (column, name, item) => {               
                        return '#/users/' + (item.user ? item.userId : "" );
                    },
                    titleCallback: (column, name, item) => {                           
                        return item.user                
                    },
                    }
                ] : [],  
                currentSort: "createdAt",
                currentSortOrder: "asc",
                pagination: {
                    perPage: 10,
                    currentPage: 1,
                    total: 0,
                    perPageOptions: [5, 10, 20, 25, 50],
                    perPageMaxLimit: 999
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                tableData: [],
                searchedData: [],
                fuseSearch: null,
                assigneeList: [],
                formatResponse: (data) => {
                    let result = [];
                    if (data && data.searchChanges && data.searchChanges.items.length) {
                        let items = data.searchChanges.items;
                        items.forEach((item) => {
                            /** Format user and change for display */
                            // item.userId = item.user ? item.user.id : '';
                            // item.user = item.user ? item.user.given_name + " " + item.user.family_name : item.owner;
                            // item.action = item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '';
                            // item.createdAt = moment(String(item.createdAt)).format("MMM DD, YYYY h:mm:ss a");
                            
                            if (item.change) {
                                //let change = JSON.stringify(JSON.parse(item.change),null,2);
                                let parseItem = JSON.parse(item.change);
                                item.userId = item.user ? item.user.id : '';
                                item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;
                                item.action = item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '';

                                // if deleted attachment log
                                if (item.action == "Remove" && parseItem.toModelType) {
                                    const newItem = {
                                    fieldName: parseItem.toModelType,
                                    newValue: "",
                                    oldValue: parseItem.name,
                                    userId: item.userId,
                                    user: item.user,
                                    //action: item.action,
                                    createdAt: moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a'),
                                    //change: change
                                    };
                                    result.push(newItem);
                                }

                                Object.keys(parseItem).forEach((k) => {
                                    if (k !== "old") {
                                        let newVal = parseItem[k];
                                        let oldVal = "";
                                        if (typeof parseItem[k] === 'object') {
                                            newVal = JSON.stringify(parseItem[k]);
                                        }

                                        //if old field exist set oldValue
                                        if (parseItem.old) {
                                            oldVal = parseItem.old[k];
                                            if (typeof parseItem.old[k] === 'object') {
                                            oldVal = JSON.stringify(parseItem.old[k]);
                                            }
                                        }
                                        if (item.action != "Remove") {
                                            const newItem = {
                                                fieldName: k,
                                                newValue: newVal,
                                                oldValue: oldVal,
                                                userId: item.userId,
                                                user: item.user,
                                                //action: item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '',
                                                createdAt: moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a'),
                                                //change: change
                                            };
                                            result.push(newItem);
                                        }
                                    }
                                });
                            }
                            //result.push(item);
                        });
                    }
                    return this.orderedAuditLog(result);
                },
            },
            defaultActiveCollapseIndex: 1,
            formConfig: {
                hasUpdatedBy: true,
                updatedByFieldName: "taskUpdatedById",
                updatedByTaskStepFieldName: "taskStepUpdatedById",
                isTemplateActive: false,
                responseFieldName: "getTask",
                removeFields: ["companies", "services", "products", "salesreps", "accounts"],
                actions: {
                    save: "createTask",
                    view: "getTask",
                    edit: "editTask",
                    new: "newTask",
                    update: "updateTask",
                    delete: "deleteTask",
                },
                slots: {
                    basic: { label: "Task Information", icon: "work", layout: { x: 0, y: 0, w: 12, h: 18, i: "0" } },
                    targets: {
                        label: "Task Targets",
                        icon: "my_location",
                        editModeOnly: true,
                        layout: { x: 0, y: 19, w: 12, h: 18, i: "1" },
                    },
                },
                listPath: "/tasks",
                headerIcon: "assignment",
                objectName: "Task",
                objectNamePlural: "Tasks",
                redirectTemp: false,
                editMode: false,
                limit: {
                    usersLimit: 999,
                    casesLimit: 999,
                    changesLimit: 999,
                    commentsLimit: 999,
                },
                casesFilter: undefined,
                pageMode: "new", // can be one of ['new', 'view' 'edit']
                fields: {
                    id: { label: "ID", type: "id", slot: "basic" },
                    subject: { label: "Subject", type: "text", slot: "basic", uniqueErrorMessage: 'Can not use this name as it is reserved.' },
                    internal: {
                        label: "Internal",
                        type: "switch",
                        slot: "basic",
                        hide: this.$Session && this.$Session.isInternalGroupMember ? false : true,
                        preventEdit: !this.$Session.isInternalGroupMember,
                    },
                    type: {
                        label: "Type",
                        type: "select",
                        slot: "basic",
                        options: [
                            { name: "Application", id: "Application" },
                            { name: "Call", id: "Call" },
                            { name: "FollowUp", id: "FollowUp" },
                            { name: "Meeting", id: "Meeting" },
                            { name: "ReviewIncomingMessage", id: "ReviewIncomingMessage" },
                            { name: "Other", id: "Other" },
                        ],
                    },
                    priority: {
                        label: "Priority",
                        type: "select",
                        slot: "basic",
                        options: [
                            { name: "High", id: "High" },
                            { name: "Low", id: "Low" },
                            { name: "Normal", id: "Normal" },
                            { name: "Rush", id: "Rush" },
                            { name: "Critical", id: "Critical" },
                        ],
                    },
                    status: {
                        label: "Status",
                        type: "select",
                        slot: "basic",
                        options: [
                            { name: "Open", id: "Open" },
                            { name: "WaitingOnCustomer", id: "WaitingOnCustomer" },
                            { name: "OnHold", id: "OnHold" },
                            { name: "Completed", id: "Completed" },
                            { name: "Closed By Workflow", id: "Closed_By_Workflow" },
                        ],
                        preventEdit: this.isTaskDisabled,
                        preventOptSelect:'Closed_By_Workflow',
                        hide: () => {
                            return !(this.formConfig.pageMode === 'new')
                        }
                    },
                    quickNote: { label: "Quick Note", type: "textarea", slot: "basic" },
                    taskUserId: {
                        label: "Assignee",
                        type: "autocomplete",
                        slot: "basic",
                        data: [],
                        displayFieldOne: "given_name",
                        displayFieldTwo: "family_name",
                        searchTerm: "",
                        options: [],
                        linkBase: "#/users/",
                        setVal: (val) => {
                            this.$v.form.taskUserId.$model = val;
                        },
                        select: (c) => {
                            (($this) => {
                                $this.setVal(c.id);
                                $this.searchTerm = c.given_name + " " + c.family_name;
                            })(this.formConfig.fields.taskUserId);
                        },
                        hasValidation: true,
                        isLazyLoadEnabled: true,
                        lazyLoadListQueryId: 'searchUsers',
                        lazyLoadResponseFieldName: 'searchUsers',
                        lazyLoadSearchableFields: ['given_name', 'family_name'],
                        hide: () => {
                            return !(this.formConfig.pageMode === 'new')
                        }
                    },
                    taskCaseId: {
                        label: "Case",
                        type: "autocomplete",
                        slot: "basic",
                        displayFieldOne: "subject",
                        data: [],
                        searchTerm: "",
                        searchTermId: "",
                        options: [],
                        linkBase: "#/cases/",
                        setVal: (val) => {
                            this.$v.form.taskCaseId.$model = val;
                        },
                        select: (c) => {
                            (($this) => {
                                $this.setVal(c.id);
                                $this.searchTermId = c.id;
                                $this.searchTerm = c.subject;
                            })(this.formConfig.fields.taskCaseId);
                        },
                        hasValidation: true,
                        isLazyLoadEnabled: true,
                        lazyLoadListQueryId: 'searchCases',
                        lazyLoadResponseFieldName: 'searchCases',
                        lazyLoadSearchableFields: ['subject'],
                        lazyLoadFilter: {
                            bool: {
                                must_not: [
                                    {
                                        match: {
                                            status: 'Merged',
                                        }
                                    }
                                ]
                            }
                        },
                        // change: (search) => {
                        //     (($this) => {
                        //         const data = $this.data;
                        //         $this.options = new Promise((resolve) => {
                        //             window.setTimeout(() => {
                        //                 if (!search) {
                        //                     $this.setVal("");
                        //                     $this.searchTerm = "";
                        //                     resolve(data);
                        //                 } else {
                        //                     const term = search.toLowerCase();
                        //                     let result = {};
                        //                     if (this.formConfig.pageMode === "view") {
                        //                         result = data.filter(({ id }) => id.toLowerCase() === this.recordData.case.id);
                        //                     } else if (this.formConfig.pageMode === "edit" && $this.searchTermId != "") {
                        //                         result = data.filter(({ id }) => id.toLowerCase() === $this.searchTermId);
                        //                     } else {
                        //                         result = data.filter(({ subject }) => subject.toLowerCase() === term);
                        //                     }
                        //                     /**
                        //                      * ATLAS-803
                        //                      * @see https://zeamster.atlassian.net/browse/ATLAS-803
                        //                      */
                        //                     // if (result.length) {
                        //                     //   $this.select(result[0]);
                        //                     // } else {
                        //                     if (!result.length) {
                        //                         $this.setVal("");
                        //                         $this.searchTerm = "";
                        //                     }
                        //                     resolve(data.filter(({ subject }) => subject.toLowerCase().includes(term)));
                        //                 }
                        //             }, 100);
                        //         });
                        //     })(this.formConfig.fields.taskCaseId);
                        // },
                    },
                    dateDue: { label: "Due Date", type: "datepicker", slot: "basic", format: "YYYY-MM-DD" },
                    isTemplate: {
                        label: "Save as Template",
                        type: "checkbox",
                        slot: "basic",
                        hide: () => !this.$reduce(this.$Session, "hasTaskSaveAsTemplate"),
                    },
                    isCompleteInOrder: { label: "Complete In Order", type: "switch", slot: "basic" },
                    companies: {
                        label: "Companies",
                        type: "searchmodal",
                        slot: "targets",
                        subscribe: {
                            onCreate: {
                                model: "TaskCompany",
                                inputField: "companies",
                                target: "company",
                            },
                            onDelete: {
                                model: "TaskCompany",
                                inputField: "companies",
                                target: "company",
                            },
                        },
                        filter: "caseCompanyCaseId.keyword",
                        list: {
                            hideNewRecordButton: true,
                            hideListHeader: true,
                            editPath: "companies",
                            objectName: "company",
                            idField: "caseCompanyCompanyId",
                            pageTitle: "Companies",
                            pageIcon: "store",
                            listQueryId: "searchCaseCompanys",
                            createMutationId: "createTaskCompany",
                            deleteQueryId: "deleteTaskCompany",
                            deleteQueryIdField: "relateRecordId",
                            deleteMessageTitle: "Are you sure you want to remove {objectName} from this Task?",
                            deleteMessageText: "",
                            linkRows: false,
                            searchRecordsInput: false,
                            itemActions: [
                                {
                                    class: "md-just-icon md-simple md-warning",
                                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                                    icon: "post_add",
                                    iconAdded: "check_circle",
                                    click: "handleAdd",
                                },
                            ],
                            columns: {
                                name: { label: "Name", sortable: false },
                                createdAt: { label: "Created", sortable: false, dateFilter: true },
                            },
                            perPageOptions: [5, 10, 20, 25, 50],
                            defaults: {
                                sort: "createdAt",
                                sortDir: "desc",
                                perPage: 10,
                            },
                            fuseSearch: null,
                            relateRecordInput: { taskCompanyCompanyId: null, taskCompanyTaskId: null },
                            relateRecordInputField: "taskCompanyCompanyId",
                            relateRecordRouteField: "taskCompanyTaskId",
                            formatResponse: (data) => {
                                this.$c.log(data);
                                let result = [];
                                let responseKey = "searchCaseCompanys";
                                if (data && data[responseKey] !== "undefined") {
                                    let items = data[responseKey].items;
                                    items.forEach((item, index) => {
                                        item["id"] = item.company.id;
                                        item["name"] = item.company.name;
                                        item["createdAt"] = item.company.createdAt;
                                        result.push(item);
                                    });
                                }
                                return result;
                            },
                        },
                    },
                    accounts: {
                        label: "Accounts",
                        type: "searchmodal",
                        slot: "targets",
                        subscribe: {
                            onCreate: {
                                model: "TaskAccount",
                                inputField: "accounts",
                                target: "account",
                            },
                            onDelete: {
                                model: "TaskAccount",
                                inputField: "accounts",
                                target: "account",
                            },
                        },
                        filter: "caseAccountCaseId.keyword",
                        list: {
                            hideNewRecordButton: true,
                            hideListHeader: true,
                            editPath: "accounts",
                            objectName: "account",
                            idField: "caseAccountAccountId",
                            pageTitle: "Accounts",
                            pageIcon: "store",
                            listQueryId: "searchCaseAccounts",
                            createMutationId: "createTaskAccount",
                            deleteQueryId: "deleteTaskAccount",
                            deleteQueryIdField: "relateRecordId",
                            deleteMessageTitle: "Are you sure you want to remove {objectName} from this Task?",
                            deleteMessageText: "",
                            linkRows: false,
                            searchRecordsInput: false,
                            itemActions: [
                                {
                                    class: "md-just-icon md-simple md-warning",
                                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                                    icon: "post_add",
                                    iconAdded: "check_circle",
                                    click: "handleAdd",
                                },
                            ],
                            columns: {
                                name: { label: "Name", sortable: false },
                                createdAt: { label: "Created", sortable: false, dateFilter: true },
                            },
                            perPageOptions: [5, 10, 20, 25, 50],
                            defaults: {
                                sort: "createdAt",
                                sortDir: "desc",
                                perPage: 10,
                            },
                            fuseSearch: null,

                            relateRecordInput: { taskAccountAccountId: null, taskAccountTaskId: null },
                            relateRecordInputField: "taskAccountAccountId",
                            relateRecordRouteField: "taskAccountTaskId",
                            formatResponse: (data) => {
                                this.$c.log(data);
                                let result = [];
                                let responseKey = "searchCaseAccounts";
                                if (data && data[responseKey] !== "undefined") {
                                    let items = data[responseKey].items;
                                    items.forEach((item, index) => {
                                        item["id"] = item.account.id;
                                        item["name"] = item.account.name;
                                        item["createdAt"] = item.account.createdAt;
                                        result.push(item);
                                    });
                                }
                                return result;
                            },
                        },
                    },
                    services: {
                        label: "Services",
                        type: "searchmodal",
                        slot: "targets",
                        subscribe: {
                            onCreate: {
                                model: "TaskService",
                                inputField: "services",
                                target: "service",
                            },
                            onDelete: {
                                model: "TaskService",
                                inputField: "services",
                                target: "service",
                            },
                        },
                        filter: "caseServiceCaseId.keyword",
                        list: {
                            hideNewRecordButton: true,
                            hideListHeader: true,
                            editPath: "services",
                            objectName: "service",
                            idField: "caseServiceServiceId",
                            pageTitle: "Services",
                            pageIcon: "store",
                            listQueryId: "searchCaseServices",
                            createMutationId: "createTaskService",
                            deleteQueryId: "deleteTaskService",
                            deleteQueryIdField: "relateRecordId",
                            deleteMessageTitle: "Are you sure you want to remove {objectName} from this Task?",
                            deleteMessageText: "",
                            linkRows: false,
                            searchRecordsInput: false,
                            itemActions: [
                                {
                                    class: "md-just-icon md-simple md-warning",
                                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                                    icon: "post_add",
                                    iconAdded: "check_circle",
                                    click: "handleAdd",
                                },
                            ],
                            columns: {
                                name: { label: "Name", sortable: false },
                                createdAt: { label: "Created", sortable: false, dateFilter: true },
                            },
                            perPageOptions: [5, 10, 20, 25, 50],
                            defaults: {
                                sort: "createdAt",
                                sortDir: "desc",
                                perPage: 10,
                            },
                            fuseSearch: null,
                            relateRecordInput: { taskServiceServiceId: null, taskServiceTaskId: null },
                            relateRecordInputField: "taskServiceServiceId",
                            relateRecordRouteField: "taskServiceTaskId",
                            formatResponse: (data) => {
                                this.$c.log(data);
                                let result = [];
                                let responseKey = "searchCaseServices";
                                if (data && data[responseKey] !== "undefined") {
                                    let items = data[responseKey].items;
                                    items.forEach((item, index) => {
                                        item["id"] = item.service.id;
                                        item["name"] = item.service.name;
                                        item["createdAt"] = item.service.createdAt;
                                        result.push(item);
                                    });
                                }
                                return result;
                            },
                        },
                    },
                    products: {
                        label: "Products",
                        type: "searchmodal",
                        slot: "targets",
                        subscribe: {
                            onCreate: {
                                model: "TaskProduct",
                                inputField: "products",
                                target: "product",
                            },
                            onDelete: {
                                model: "TaskProduct",
                                inputField: "products",
                                target: "product",
                            },
                        },
                        filter: "caseProductCaseId.keyword",
                        list: {
                            hideNewRecordButton: true,
                            hideListHeader: true,
                            editPath: "products",
                            objectName: "product",
                            idField: "caseProductProductId",
                            pageTitle: "Products",
                            pageIcon: "store",
                            listQueryId: "searchCaseProducts",
                            createMutationId: "createTaskProduct",
                            deleteQueryId: "deleteTaskProduct",
                            deleteQueryIdField: "relateRecordId",
                            deleteMessageTitle: "Are you sure you want to remove {objectName} from this Task?",
                            deleteMessageText: "",
                            linkRows: false,
                            searchRecordsInput: false,
                            itemActions: [
                                {
                                    class: "md-just-icon md-simple md-warning",
                                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                                    icon: "post_add",
                                    iconAdded: "check_circle",
                                    click: "handleAdd",
                                },
                            ],
                            columns: {
                                name: { label: "Name", sortable: false },
                                createdAt: { label: "Created", sortable: false, dateFilter: true },
                            },
                            perPageOptions: [5, 10, 20, 25, 50],
                            defaults: {
                                sort: "createdAt",
                                sortDir: "desc",
                                perPage: 10,
                            },
                            fuseSearch: null,
                            relateRecordInput: { taskProductProductId: null, taskProductTaskId: null },
                            relateRecordInputField: "taskProductProductId",
                            relateRecordRouteField: "taskProductTaskId",
                            formatResponse: (data) => {
                                this.$c.log(data);
                                let result = [];
                                let responseKey = "searchCaseProducts";
                                if (data && data[responseKey] !== "undefined") {
                                    let items = data[responseKey].items;
                                    items.forEach((item, index) => {
                                        item["id"] = item.product.id;
                                        item["name"] = item.product.name;
                                        item["createdAt"] = item.product.createdAt;
                                        result.push(item);
                                    });
                                }
                                return result;
                            },
                        },
                    },
                    salesreps: {
                        label: "SalesReps",
                        type: "searchmodal",
                        slot: "targets",
                        subscribe: {
                            onCreate: {
                                model: "TaskSalesRep",
                                inputField: "salesreps",
                                target: "salesrep",
                            },
                            onDelete: {
                                model: "TaskSalesRep",
                                inputField: "salesreps",
                                target: "salesrep",
                            },
                        },
                        filter: "caseSalesRepCaseId.keyword",
                        list: {
                            hideNewRecordButton: true,
                            hideListHeader: true,
                            editPath: "salesreps",
                            objectName: "salesrep",
                            idField: "caseSalesRepSalesrepId",
                            pageTitle: "Sales Rep",
                            pageIcon: "store",
                            listQueryId: "searchCaseSalesReps",
                            createMutationId: "createTaskSalesRep",
                            deleteQueryId: "deleteTaskSalesRep",
                            deleteQueryIdField: "relateRecordId",
                            deleteMessageTitle: "Are you sure you want to remove {objectName} from this Task?",
                            deleteMessageText: "",
                            targetName: "given_name",
                            linkRows: false,
                            searchRecordsInput: false,
                            itemActions: [
                                {
                                    class: "md-just-icon md-simple md-warning",
                                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                                    icon: "post_add",
                                    iconAdded: "check_circle",
                                    click: "handleAdd",
                                },
                            ],
                            columns: {
                                name: { label: "Given Name", sortable: false },
                                createdAt: { label: "Created", sortable: false, dateFilter: true },
                            },
                            perPageOptions: [5, 10, 20, 25, 50],
                            defaults: {
                                perPage: 10,
                                sort: "createdAt",
                                sortDir: "desc",
                            },
                            fuseSearch: null,
                            relateRecordInput: { taskSalesRepSalesrepId: null, taskSalesRepTaskId: null },
                            relateRecordInputField: "taskSalesRepSalesrepId",
                            relateRecordRouteField: "taskSalesRepTaskId",
                            formatResponse: (data) => {
                                this.$c.log(data);
                                let result = [];
                                let responseKey = "searchCaseSalesReps";
                                if (data && data[responseKey] !== "undefined") {
                                    let items = data[responseKey].items;
                                    items.forEach((item, index) => {
                                        item["id"] = item.salesrep.id;
                                        item["name"] = item.salesrep.given_name;
                                        item["createdAt"] = item.salesrep.createdAt;
                                        result.push(item);
                                    });
                                }
                                return result;
                            },
                        },
                    },
                },
                editTitleField: "name",
            },
            form: {
                id: "",
                subject: "",
                internal: false,
                type: "",
                priority: "",
                status:
                    "Open" /**modified code for ATLAS-725 - ATLAS-676: Task Form Changes * Set default values on form load */,
                quickNote: "",
                isTemplate: false,
                taskUserId: "",
                taskCaseId: "",
                dateDue: new Date() /**modified code for ATLAS-725 - ATLAS-676: Task Form Changes * Set default values on form load */,
                isCompleteInOrder: false,
                companies: [],
                accounts: [],
                services: [],
                products: [],
                salesreps: [],
            },
            feedPage: 1,
            feedItemsPerPage: 5,
            feedFiltered: [],
            showEditorFlag: false,
            comment: {
                body: "",
                internal: false,
            },
            attachments: [],
            attachmentData: [],
            isInternal: false,
            commentId: null,
            snackbarMsg: '',
            isSnackbarOpen: false,
            isBusy: false,
            updateFormData: {},
            atMentionsCommentList: [],
            atMentionsUserList: [],
            subscriptions: {
                onUpdateTask: {
                    result: null,
                    load: true,
                    function: (eventData) => {
                        const task = this.$reduce(eventData, 'value.data.onUpdateTask');
                        if (task && task.case && task.case.id && task.case.id == this.$route.params.id) {
                            this.$c.log("SUBSCRIPTION Trigger: onUpdateTask");
                            this.$c.log(eventData);
                            if (task.id == this.recordData.id) {
                                let curTaskUserId = this.recordData.taskUserId;
                                if (!task.user && curTaskUserId) {
                                    this.formConfig.fields.taskUserId.searchTerm = "";
                                    this.form.taskUserId = "";
                                } else if (task.user && !this.recordData.taskUserId) {
                                    this.formConfig.fields.taskUserId.searchTerm = task.user.given_name + ' ' + task.user.family_name;
                                    this.form.taskUserId = task.user.id;
                                }
                            }
                        }
                    }
                },
                onCreateComment: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: (eventData) => {
                        this.$c.log("SUBSCRIPTION Trigger: onCreateComment");
                        this.$c.log(eventData);
                        let activeModelId = this.$route.params.id;
                        if (this.iframeModelId) {
                            activeModelId = this.iframeModelId;
                        }
                        if (eventData.value.data.onCreateComment && eventData.value.data.onCreateComment.parentComment) {
                            let findIndexRes = _.findIndex(this.updateFormData.searchComments.items, {
                                id: eventData.value.data.onCreateComment.parentComment.id,
                            });
                            if (findIndexRes != -1) {
                                let findIndexResIndex = _.findIndex(
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items,
                                    {
                                        id: eventData.value.data.onCreateComment.id,
                                    }
                                );
                                if (findIndexResIndex == -1) {
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items.unshift(
                                        eventData.value.data.onCreateComment
                                    );
                                    this.updateFeedItems(this.updateFormData);
                                }
                            }
                        } else if (
                            eventData.value.data.onCreateComment &&
                            eventData.value.data.onCreateComment.task &&
                            eventData.value.data.onCreateComment.task.id == activeModelId
                        ) {
                            let findIndexRes = _.findIndex(this.updateFormData.searchComments.items, {
                                id: eventData.value.data.onCreateComment.id,
                            });
                            if (findIndexRes == -1) {
                                this.updateFormData.searchComments.items.unshift(eventData.value.data.onCreateComment);
                                this.updateFeedItems(this.updateFormData);
                            }
                        }
                    },
                },
                onCreateRelation: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: (eventData) => {
                        this.$c.log("SUBSCRIPTION Trigger: onCreateRelation");
                        this.$c.log(eventData);
                        this.updateFeedItems(this.updateFormData);
                    },
                },
                'onUpdateRelation': {
                    result: null,
                    load: true,
                    function: (eventData) => {                      
                      let eventRecord = eventData.value.data.onUpdateRelation   
                      if (eventRecord.esData) {
                        let esData = JSON.parse(eventRecord.esData);
                        if(esData.fromModelType === 'Task' && esData.task && this.$route.params.id === esData.task.id){
                          this.$c.log('SUBSCRIPTION MATCH!: onUpdateRelation');
                          this.$c.log("eventData: ", eventData);
                          // timeout of 5ms for elastic search
                          setTimeout(() => this.$refs.attachmentsListRefs.onSearch(), 500);
                        }
                      }
                    }
                },
                onDeleteComment: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: (eventData) => {
                        this.$c.log("SUBSCRIPTION Trigger: onDeleteComment");
                        this.$c.log(eventData);
                        if (eventData.value.data.onDeleteComment.parentComment) {
                            let findIndexRes = _.findIndex(this.updateFormData.searchComments.items, {
                                id: eventData.value.data.onDeleteComment.parentComment.id,
                            });
                            if (findIndexRes != -1) {
                                let findIndexResIndex = _.findIndex(
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items,
                                    {
                                        id: eventData.value.data.onDeleteComment.id,
                                    }
                                );
                                if (findIndexResIndex != -1) {
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items.splice(findIndexResIndex, 1);
                                    this.updateFeedItems(this.updateFormData);
                                }
                            }
                        }
                    },
                },
                onUpdateComment: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: (eventData) => {
                        this.$c.log("SUBSCRIPTION Trigger: onUpdateComment");
                        this.$c.log(eventData);
                        if (eventData.value.data.onUpdateComment.parentComment) {
                            let findIndexRes = _.findIndex(this.updateFormData.searchComments.items, {
                                id: eventData.value.data.onUpdateComment.parentComment.id,
                            });
                            if (findIndexRes != -1) {
                                let findIndexResIndex = _.findIndex(
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items,
                                    {
                                        id: eventData.value.data.onUpdateComment.id,
                                    }
                                );
                                if (findIndexResIndex != -1) {
                                    this.updateFormData.searchComments.items[findIndexRes].comments.items[findIndexResIndex] =
                                        eventData.value.data.onUpdateComment;
                                    this.updateFeedItems(this.updateFormData);
                                }
                            }
                        }
                    },
                },
                onCreateChange: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: (eventData) => {
                        let activeModelId = this.$route.params.id;
                        if (this.iframeModelId) {
                            activeModelId = this.iframeModelId;
                        }
                        if (
                            eventData.value.data.onCreateChange.modelName == "Task" &&
                            eventData.value.data.onCreateChange.modelId == activeModelId
                        ) {
                            this.$c.log("SUBSCRIPTION Trigger: onCreateChange");
                            this.$c.log(eventData);

                            let findIndexRes = _.findIndex(this.updateFormData.searchChanges.items, {
                                id: eventData.value.data.onCreateChange.id,
                            });
                            if (findIndexRes == -1) {
                                this.updateFormData.searchChanges.items.unshift(eventData.value.data.onCreateChange);
                                this.updateFeedItems(this.updateFormData);
                            }
                        }
                    },
                },
                onCreateRelation: {
                    /** We will save the subscription to result so we can destroy it later */
                    result: null,
                    load: true,
                    function: eventData => {
                        this.$c.log("SUBSCRIPTION Trigger: onCreateRelation");
                        this.$c.log(eventData);
                        if (this.$refs.attachmentsListRefs) {
                            clearTimeout(this.attachmentsTimeoutId);
                            this.attachmentsTimeoutId = setTimeout(() => {
                                this.$refs.attachmentsListRefs.onSearch();
                                this.updateFeedItems(this.updateFormData);
                            }, 2000);
                        } else {
                            this.updateFeedItems(this.updateFormData);
                        }
                    }
                },
            },
        };
    },
    validations() {
        return {
            form: {
                id: {},
                subject: { required, minLength: minLength(3),
                    async isUnique(value) {
                        if (value.trim().length < 3) {
                          return true;
                        }
                        const timeoutInterval = this.isFirstTimeReservedNameCheck ? 0 : 3000;
                        this.isFirstTimeReservedNameCheck = false;
                        clearTimeout(this.reservedNameValidatorTimeoutId);
                        return new Promise(async (resolve, reject) => {
                          this.reservedNameValidatorTimeoutId = setTimeout(async () => {
                            const valueTrimmed = value.trim();
                            let params = {limit:999};
                            params.filter = {esQuery: JSON.stringify({"match": {"hasWorkflow": true }})};                    
                            params.limit = 999;
                            const query = queries_custom['searchTasksSteps'];
                            await API.graphql(graphqlOperation(query, params))
                              .then(result => {
                                if (
                                  result.data && 
                                  result.data.searchTasks && 
                                  result.data.searchTasks.items
                                ) {
                                  const index = result.data.searchTasks.items.findIndex(_item => {
                                    return _item.subject.toLowerCase() == valueTrimmed.toLowerCase();
                                  });
                                  if (-1 === index) {
                                    return resolve(true);
                                  }else if(this.recordData && this.recordData.isSystemCreated){
                                    return resolve(true);
                                  }
                                  return reject(false);
                                }
                                reject(false);
                              })
                              .catch(err => {
                                if (
                                  err &&
                                  err.errors &&
                                  err.errors[0].errorType &&
                                  'Elasticsearch:UserIllegalArgumentException' == err.errors[0].errorType
                                ) {
                                  resolve(true);
                                }
                                reject(false);
                              });
                          }, timeoutInterval);
                        });
                    }        
                },
                internal: {},
                type: { required },
                priority: { required },
                status: { required },
                quickNote: {},
                isTemplate: {},
                taskUserId: {
                    isValid: this.isTaskUserIdValid,
                },
                taskCaseId: {
                    required,
                    isValid: this.isTaskCaseIdValid,
                },
                dateDue: { required },
                isCompleteInOrder: {},
                companies: {},
                accounts: {},
                services: {},
                products: {},
                salesreps: {},
            },
        };
    },
    methods: {
        scrollToHash(hash) {
            console.log("hash val:", hash);
            if (hash) {
                let element = document.getElementById(hash);
                if (element) {
                    const top = element.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top, // scroll so that the element is at the top of the view
                        behavior: "smooth", // smooth scroll
                    });
                }
            }
        },
        orderedAuditLog: function (items) {
            return _.orderBy(items, "createdAt", "desc");
        },
        onShowAuditLog() {
            this.auditLogDialog = true;
        },
        async updateFeedItems(data) {
            let items = await this.prepareFeedData(data);
            this.sortFeedData(items);
            this.feedFiltered = items;

            if (this.$route.hash) {
                let id = this.$route.hash.replace("#", "");
                setTimeout(() => this.scrollToHash(id), 1200);
            }
        },
        async updateFormAfter(data) {
            if (typeof data === "undefined") return;
            this.updateFormData = data;

            this.loadUsers(data);
            this.loadCases(data);
            if (typeof data.getTask !== "undefined" && data.getTask.user == null) {
                this.formConfig.fields.taskUserId.searchTerm = "";
            }
            if (this.recordData) {
                if (this.recordData.dateDue) {
                    this.$v.form.dateDue.$model = new Date(this.recordData.dateDue);
                    // this.$v.form.dateDue.$reset();
                }
            }

            this.loadRelatedRecords(data, "companies", "company");
            this.loadRelatedRecords(data, "accounts", "account");
            this.loadRelatedRecords(data, "services", "service");
            this.loadRelatedRecords(data, "products", "product");
            this.loadRelatedRecords(data, "salesreps", "salesrep");

            await this.updateFeedItems(data);
        },
        loadRelatedRecords(data, name, target) {
            let result = [];
            if (data && data.getTask && data.getTask[name] && data.getTask[name].items && data.getTask[name].items.length) {
                let items = data.getTask[name].items;
                items.forEach((item) => {
                    item[target].relateRecordId = item.id;
                    result.push(item[target]);
                });
            }
            this.form[name] = result;
        },
        loadUsers(data) {
            (($this) => {
                //$this.data = data.listUsers.items;
                $this.data = [];
                if (this.recordData && this.recordData.user) {
                    $this.searchTerm = this.recordData.user.given_name + " " + this.recordData.user.family_name;
                    this.form.taskUserId = this.recordData.user.id;
                } else {
                    if (this.$route.query.taskUserId) {
                        this.$v.form.taskUserId.$model = this.$route.query.taskUserId;
                        /** try to find the User name */
                        let matchingIndex = $this.data.findIndex((item) => item.id === this.form.taskUserId);
                        if (matchingIndex >= 0) {
                            $this.searchTerm = $this.data[matchingIndex].given_name;
                        }
                    }
                }
            })(this.formConfig.fields.taskUserId);
        },
        loadCases(data) {
            (($this) => {
                $this.data = [];
                // if (data.listCases && data.listCases.items) {
                //     const thisData = [];
                //     data.listCases.items.forEach((element) => {
                //         if (element.status != "Merged") {
                //             thisData.push(element);
                //         }
                //     });
                //     $this.data = thisData;
                // }

                if (this.recordData && this.recordData.case) {
                    $this.searchTerm = this.recordData.case.subject;
                    this.form.taskCaseId = this.recordData.case.id;
                } else {
                    if (this.$route.query.taskCaseId) {
                        this.$v.form.taskCaseId.$model = this.$route.query.taskCaseId;
                        /** try to find the User name */
                        let matchingIndex = $this.data.findIndex((item) => item.id === this.form.taskCaseId);
                        if (matchingIndex >= 0) {
                            $this.searchTerm = $this.data[matchingIndex].subject;
                        }
                    }
                }
            })(this.formConfig.fields.taskCaseId);
        },
        async prepareFeedData(data) {
            const items = [];
            if (data.searchChanges && data.searchChanges.items) {
                let filterChange = ["status", "taskUserId"];
                data.searchChanges.items.map((_change) => {
                    const change = JSON.parse(JSON.stringify(_change));
                    let updateChangeItem = {};
                    try {
                        updateChangeItem = JSON.parse(change.change);
                        if ("object" !== typeof updateChangeItem) {
                            try {
                                // for items received via subscriptions - the change is a slash
                                // escaped string - try and decode the string
                                // remove double quotes from start and end / remove backslashes
                                let changeJsonStr = change.change
                                    .replace(/^"/, "")
                                    .replace(/"$/, "")
                                    .replace(/\\/gi, "");
                                updateChangeItem = JSON.parse(changeJsonStr);
                            } catch (e) {
                                updateChangeItem = {};
                            }
                        }
                    } catch (e) {
                        updateChangeItem = {};
                    }
                    let changeKey = Object.keys(updateChangeItem);
                    if (change.action == "modify" || change.action == "insert" || (change.action == "remove")) {
                        const compareChanges = filterChange.filter((element) => {
                            return (
                                changeKey.includes(element)
                                || (updateChangeItem.fromModelType === 'Task' && updateChangeItem.toModelType === 'Attachment')
                            );
                        });
                        if (compareChanges.length >= 1) {
                            let activity = this.arrangeChange(updateChangeItem, change.action);
                            console.log("Change Activity", activity);
                            if (activity && activity.length && "object" == typeof activity) {
                                activity.forEach((_activity) => {
                                    const newChange = _.cloneDeep(change);
                                    newChange._type = "change";
                                    newChange._activity = _activity;
                                    items.push(newChange);
                                });
                            }
                        }
                    }
                });
            }
            if (data.searchComments && data.searchComments.items) {
                data.searchComments.items.map((_comment) => {
                    const comment = JSON.parse(JSON.stringify(_comment));
                    comment._type = "comment";
                    if (comment.parentComment == null) items.push(comment);
                });
            }
            let newItems = []
            for (const _item of items) {
                console.log("Comment Item => ", _item)
                let attachment = await this.getAttachment(_item.id);
                const comment = _item;
                this.$set(comment, 'attachment', attachment);
                console.log("Comment New Item => ", comment);
                newItems.push(comment)
            }
            console.log("Item List => ",newItems);
            return newItems;
        },
        /**
        * Get attachment Types Enum
        * @returns {Array} array of objects holding enum options
        */
        async getAttachment(commentId) {
            console.log("Get ATtachment", commentId)
            return new Promise((resolve, reject) => {
            let operation = graphqlOperation(queries_custom.searchCaseAttachments, { filter: { 
                relationCommentId: { eq: commentId }
            }, limit: 999 });
            console.log("ATtachment operation => ", operation);
            API.graphql(operation)
            .then(async response => {
            let values = this.$reduce(response, 'data.searchRelations.items');
            console.log("ATtachment Data => ", values);
            let options = [];
            const amplifyEnv = aws_exports.aws_content_delivery_bucket.match(/.*-(\w+)/)[1]
            const s3Bucket = 'atlasemailattachments-' + amplifyEnv 
            for (const _value of values) {
                if (_value.attachment.isDeleted === null || _value.attachment.isDeleted === undefined || _value.attachment.isDeleted === false) {
                    const url = await Storage.get(_value.attachment.s3Path, {
                        bucket: aws_exports.aws_user_files_s3_bucket,
                        region: aws_exports.aws_user_files_s3_bucket_region,
                    });
                    options.push({
                        id: _value.attachment.id,
                        description: _value.attachment.description,
                        name: _value.attachment.name,
                        s3Key: _value.attachment.s3Path,
                        s3Path: url,
                        type: _value.attachment.type.replace(/_/ig, ' '),
                        internal: _value.attachment.internal
                    });
                }   
            }
            resolve(options.length > 0 ? options : null);
            })
            .catch(err => {
            console.log('getAttachment - Error', err);
            resolve(null);
            });
            });
        },
        /**
         * Add activity logs/feed in array per condition to show on feed tab
         */
        arrangeChange(changeItem, action) {
            let activity = [];
            if (action == "insert") {
                // add attachment feed else new task feed
                if(
                  typeof changeItem.name !== 'undefined'
                  && typeof changeItem.fromModelType !== 'undefined'
                  && typeof changeItem.toModelType !== 'undefined'
                ) {
                  activity.push(` attached a file ${changeItem.name}`);
                } else {
                    activity.push(" Created a new task.");
                }
            }
            
            if (action == "modify") {
                if (typeof changeItem.status != "undefined") {
                    activity.push(" Changed the task status to - " + changeItem.status.replace(/_/g, " ") + ".");
                }
                if (typeof changeItem.taskUserId != "undefined") {
                    let userName =  this.userListItems.filter(data =>  
                        data.id === changeItem.taskUserId
                    )
                    if(userName.length != 0){
                        var name = userName[0].name.replace(/_/g, ' ')
                        activity.push(" Assigned the task to user " + name);
                    }
                    else 
                        activity.push(" Assigned the task to user " + changeItem.taskUserId + ".");
                }
            }
            if (action == "remove") {
                //remove attachment feed
                if(
                    typeof changeItem.name !== 'undefined'
                    && typeof changeItem.fromModelType !== 'undefined'
                    && typeof changeItem.toModelType !== 'undefined'
                ) {
                    activity.push(` deleted a file ${changeItem.name}`);
                }
            }
            return activity;
        },
        sortFeedData(items) {
            items.sort((prev, next) => {
                const prevDate = new Date(prev.createdAt).getTime();
                const nextDate = new Date(next.createdAt).getTime();
                if (prevDate < nextDate) {
                    return 1;
                }
                if (prevDate > nextDate) {
                    return -1;
                }
                return 0;
            });
        },
        feedHasMore() {
            return this.feedFiltered.length > this.feedActive.length;
        },
        loadNextFeedData() {
            this.feedPage++;
        },
        showEditor(mode) {
            this.showEditorFlag = true;
            setTimeout(() => {
                window.$bus.$emit("focusTinyMceEditor", { id: mode });
            }, 300);
        },
        closeEditor(editor) {
            this[editor].body = "";
            this.attachmentData = [];
            window.$bus.$emit("refreshTinyMceEditor", { id: editor, content: "" });
            this.showEditorFlag = false;
        },
        async sendComment() {
            let commentStr = this.getCommentAsPlainText();
            if (!commentStr.length) {
                this.promisePending = true;
                await this.storeAttachmentsOnly();
                this.cleanupAfterComment();
                return;
            }            
            
            this.promisePending = true;
            let inputCommentData = {
                internal: this.comment.internal,
                commentTaskId: this.recordData.id,
                commentUserId: this.$Session.userId,
            };

            let error = null;
            const s3Key = `comments/${uuidv4()}`;
            const s3Response = await Storage
                .put(s3Key, this.comment.body, {
                    bucket: aws_exports.aws_user_files_s3_bucket,
                    region: aws_exports.aws_user_files_s3_bucket_region
                })
                .catch(err => {
                    error = err;
                    console.log('Error uploading comment to S3', err)
                });
                
            if (error) {
                this.snackbarMsg = error.message || 'Something went wrong. Please try again.';
                this.isSnackbarOpen = true;
                this.promisePending = false;
                return;
            }
      
            inputCommentData.s3Url = s3Key;

            //get atMention user data
            this.getAtMentionUsers(this.comment.body);

            //add data for atMentions key
            if (this.atMentionsUserList && this.atMentionsUserList.length) {
                let atMentionsList = {
                    items: this.atMentionsUserList,
                };
                inputCommentData.atMentions = JSON.stringify(atMentionsList);
            }

            /**
             * ATLAS-877 - Add Updatedby to all Models in the Schema
             * @see https://zeamster.atlassian.net/browse/ATLAS-877
             */
            inputCommentData["commentUpdatedById"] = this.$reduce(this, "$Session.userId");

            let gqlRequest = graphqlOperation(mutations["createComment"], {
                input: inputCommentData,
            });
            this.$c.log("gqlRequest", gqlRequest);
            this.isBusy = true;
            const result = await API.graphql(gqlRequest)
                .then(async (result) => {
                    this.$c.log(result);
                    this.commentId = result.data.createComment.id;
                    setTimeout(() => this.scrollToHash(result.data.createComment.id), 1200);
                    this.attachments = this.attachmentData
                    await this.add(this.getCommentAttachmentRelations())
                    this.closeEditor("comment")
                    this.isBusy = false
                    this.promisePending = false
                })
                .catch((error) => {
                    this.$c.log("error ", error);
                    this.closeEditor("comment");
                    this.isBusy = false;
                    this.attachments = []
                    this.promisePending = false
                });
        },
        generateCasesFilter() {
            if (this.$Session.isInternalGroupMember) {
                this.formConfig.casesFilter = undefined;
                return;
            }
            this.formConfig.casesFilter = { internal: { eq: false } };
        },
        async getUserList() {
            console.log("getUserList function");
            const users = [];
            const limit = 999;
            let hasNext = true;
            let nextToken = 0;
            while (hasNext) {
            // fetch users
            const response = await API.graphql(graphqlOperation(queries["searchUsers"], { limit, nextToken }));
            const items = this.$reduce(response, 'data.searchUsers.items') || [];
            // format response and add to list
            for (const _item of items) {
                users.push({
                id : _item.id,
                name: _item.given_name +"_"+ _item.family_name,
                email: _item.email
                });
            }
            // if number of items is equal to limit then next page is available
            hasNext = limit === items.length;
            nextToken += limit;
            }
            // assign users
            this.userListItems = users;
        },
        commentItemSelected(item) {
            this.atMentionsCommentList.push(item);
        },
        getAtMentionUsers(commentData) {
            this.atMentionsCommentList.forEach((el) => {
                if (commentData.includes(el.name)) {
                    if (this.atMentionsUserList.indexOf(el.id) == -1) {
                        this.atMentionsUserList.push(el.id);
                    }
                }
            });
        },
        getCommentAttachmentRelations() {
            const relations = [
                { fromModelType: 'Comment', relationCommentId: this.commentId },
                { fromModelType: 'Task', relationTaskId: this.recordData.id },
            ]

            if (this.recordData.case) {
                relations.push({ fromModelType: 'Case', relationCaseId: this.recordData.case.id })
            }

            // if (this.recordData.services && this.recordData.services.items && this.recordData.services.items.length) {
            //     for (const _service of this.recordData.services.items) {
            //         relations.push({ fromModelType: 'Service', relationServiceId: _service.id })
            //     }
            // } else {
            //     const serviceItems = this.$reduce(this, 'recordData.case.services.items') || [];
            //     for (let i = 0; i < serviceItems.length; i++) {
            //         const serviceId = this.$reduce(serviceItems, `${i}.service.id`);
            //         if (serviceId) {
            //             relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
            //         }
            //     }
            // }

            const serviceItems = this.$reduce(this, 'recordData.case.services.items') || [];
            for (let i = 0; i < serviceItems.length; i++) {
                const serviceId = this.$reduce(serviceItems, `${i}.service.id`);
                if (serviceId) {
                    relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
                }
            }
            
            return relations
        },
        getLinkConfigs() {
            if (this.$Session.isAdminGroupMember) {
                this.auditLogList.linkConfigs = [
                {
                    name: 'user',
                    hrefCallback: (column, name, item) => {               
                    return '#/users/' + (item.user ? item.userId : "" );
                    },
                    titleCallback: (column, name, item) => {                           
                        return item.user                
                    },
                }
                ]

                if (this.$refs.auditLogListRef) {
                this.$refs.auditLogListRef.refresh();
                }

            }
        },
        /**
         * Validate task user selection
         * @param {String} value the selected user ID
         * @returns {Promise}
         */
        async isTaskUserIdValid(value) {
            // normalized value
            const valueNormalized = value ? value.toString().trim() : "";
            
            // current field
            const field = this.formConfig.fields.taskUserId;
            
            // value is empty and there is no search term
            if (!valueNormalized && !field.searchTerm) {
                return true;
            }
            
            // clear existing timeout
            clearTimeout(field.timeoutId);
            
            // query name
            const queryName = 'getUser';
            
            // run new validation
            return new Promise(async (resolve, reject) => {
                field.timeoutId = setTimeout(() => {
                    API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
                        .then(res => {
                            const data = res.data[queryName];
                            const name = `${data.given_name} ${data.family_name}`;
                            if (name === field.searchTerm) {
                                return resolve(true);
                            }
                            return reject(false);
                        })
                        .catch(err => {
                            return reject(false);
                        })
                }, 500);
            });
        },
        /**
         * Validate task case selection
         * @param {String} value the selected case ID
         * @returns {Promise}
         */
        async isTaskCaseIdValid(value) {
            // normalized value
            const valueNormalized = value.toString().trim();
            
            // current field
            const field = this.formConfig.fields.taskCaseId;
            
            // value is empty and there is no search term
            if (!valueNormalized && !field.searchTerm) {
                return true;
            }
            
            // clear existing timeout
            clearTimeout(field.timeoutId);
            
            // query name
            const queryName = 'getCase';
            
            // run new validation
            return new Promise(async (resolve, reject) => {
                field.timeoutId = setTimeout(() => {
                    API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
                        .then(res => {
                            const name = this.$reduce(res, `data.${queryName}.subject`);
                            if (name === field.searchTerm) {
                                return resolve(true);
                            }
                            return reject(false);
                        })
                        .catch(err => {
                            return reject(false);
                        })
                }, 500);
            });
        },
        getCommentAsPlainText() {
            return this.comment.body
                .replace(/(<([^>]+)>)/gi, '')
                .replace(/&nbsp;/ig, '')
                .replace(/\s{2,}/ig, ' ')
                .trim();
        },
        async storeAttachmentsOnly() {
            // prepare variables
            let error = null;
            this.attachments = this.attachmentData;
            
            // store attachments and relations
            await this.add(this.attachmentRelations).catch(err => error = err);
            if (error) {
                this.showSnackbar(null, error);
                return;
            }
            
            // show snackbar message and cleanup
            this.showSnackbar('Comment added successfully');
        },
        cleanupAfterComment() {
            this.commentId = null;
            this.attachments = [];
            this.isBusy = false;
            this.promisePending = false;
            this.closeEditor('comment');
        },
        showSnackbar(msg, err) {
            let str = 'Something went wrong - please try again!';
            if (msg) {
                str = msg;  
            } else if (err && err.message) {
                str = err.message;
            }
            this.snackbarMsg = str;
            this.isSnackbarOpen = true;
        },
    },
    beforeMount() {
        this.generateCasesFilter();
    },
    mounted() {
        this.getUserList();
    },
    watch: {
        "$Session.isInternalGroupMember": {
            immediate: true,
            handler: function () {
                this.generateCasesFilter();
            },
        },
        '$Session.isAdminGroupMember'(){
            this.getLinkConfigs();
        },
        isTaskDisabled: {
            immediate: true,
            handler: function () {
                this.$set(this.formConfig.fields.status, "preventEdit", this.isTaskDisabled);
            },
        },
    },
};
